import React from 'react';
import {connect} from 'react-redux';
import {
  Grid,
  Card,
  Header,
  Loader,
  Item,
  Tab,
  Menu,
  Dropdown,
  Radio,
  Pagination,
} from 'semantic-ui-react';
import _ from 'lodash';
import {Link} from 'react-router-dom';
import {
  ISOToDisplayDate,
  evaluateOperator,
  ENTITY_TYPE_NAME_MAP,
  getTimestampNowISO,
} from 'common/utils';
import {
  canViewPostAwardEntities,
  canContinueApplications,
  canViewAndContinueApplication,
  isSubAOR,
  canViewThingsToDo,
} from 'go/security/permissions';
import {
  STATUS_AWARD_OFFERED,
  STATUS_AWARD_ACCEPTED,
  BEFORE_FINAL_SUBMISSION_STATUSES,
  STATUS_SUBMITTED_TO_FEMA,
  NUM_ACTIONS_TO_SHOW,
  PROGRAM_TYPE_PASSTHROUGH,
} from 'app-ui-componentlibrary/dist/common/constants';
import {Redirect} from 'react-router';
import REST from 'go/requests/rest';
import {
  ROLE_MAP,
  ASSOCIATED_ENTITY_STATUSES,
} from 'app-ui-componentlibrary/dist/common/constants';
import {getUniqs} from 'common/utils';
import {Alert} from 'app-ui-componentlibrary/dist/componentLibrary/layout';

const NEW_GRANT_ROLE_PERMISSIONS = [
  ROLE_MAP.ORGAOR.code,
  ROLE_MAP.ORGMEMBER.code,
  ROLE_MAP.ORGPGMMEMBER.code,
  ROLE_MAP.ORGGRNTWRITER.code,
  ROLE_MAP.ORGFINMEMBER.code,
];

const NEW_AWARD_PERMISSIONS = [
  ROLE_MAP.ORGAOR.code,
  ROLE_MAP.ORGMEMBER.code,
  ROLE_MAP.ORGPGMMEMBER.code,
  ROLE_MAP.ORGFINMEMBER.code,
];

const NEW_SUB_RECPT_PERMISSIONS = [ROLE_MAP.SUBAUTHREP.code, ROLE_MAP.SUBMEMBER.code];

export class MyWorkCard extends React.PureComponent {
  constructor(props) {
    super(props);

    this.permObj = _.reduce(
      props.permissions,
      (result, permission) => {
        const [entityTypeId, , roleId] = permission.split(':');
        if (_.indexOf(result.types, entityTypeId) === -1) {
          result.entityTypes.push(entityTypeId);
        }
        if (_.indexOf(result.roles, roleId) === -1) {
          result.roles.push(roleId);
        }
        return result;
      },
      {entityTypes: [], roles: []}
    );
    if (
      !_.isEmpty(props.grants) &&
      _.intersection(NEW_GRANT_ROLE_PERMISSIONS, this.permObj.roles).length > 0
    ) {
      this.getActionsFromGrants(props.grants);
    }

    REST.ref
      .getCodelist('PROGRAM_CATEGORY')
      .then((response) => response.json())
      .then((data) => {
        this.setState({programCategories: data.PROGRAM_CATEGORY});
      });
  }

  removeSavedForLater = (id, activePage, activeItem, sortingDirection) => {
    REST.dynamicData.unsaveForLater(id).then((res) => {
      if (res.ok) {
        const activeItemValue = this.getActiveSortValue(activeItem);
        this.props.retrieveUserSavedForLater(
          this.props.token,
          this.props.organizationId,
          10,
          (activePage - 1) * 10,
          activeItemValue,
          sortingDirection == 'Descending' ? 'DESC' : 'ASC'
        );
      }
    });
  };

  getActiveSortValue = (activeItem) => {
    switch (activeItem) {
      case 'Funding opportunity name':
        return 'fundingOpportunityName';
      case 'Organization':
        return 'organizationName';
      case 'Suborganization':
        return 'subOrganizationName';
      case 'Date in queue':
        return 'entryDate';
      case 'Due date':
        return 'dueDate';
      case 'Grant ID':
        return 'grantID';
      case 'Subgrant ID':
        return 'subGrantID';
    }
  };

  sortSavedForLater = async (sortingDirection, activeItemSavedForLater, pageNumber) => {
    await this.props.retrieveUserSavedForLater(
      this.props.token,
      this.props.organizationId,
      10,
      (pageNumber - 1) * 10,
      this.getActiveSortValue(activeItemSavedForLater),
      sortingDirection == 'Descending' ? 'DESC' : 'ASC'
    );
  };

  sortThingsToDo = async (sortingDirection, activeItem, pageNumber) => {
    await this.props.retrieveUserThingsToDo(
      this.props.token,
      this.props.organizationId,
      this.props.orgIds,
      this.props.subOrgIds,
      10,
      (pageNumber - 1) * 10,
      this.getActiveSortValue(activeItem),
      sortingDirection == 'Descending' ? 'DESC' : 'ASC'
    );
  };

  componentDidUpdate(prevProps) {
    if (
      !_.isEqual(prevProps.grants, this.props.grants) ||
      !_.isEqual(prevProps.tasks, this.props.tasks) ||
      !_.isEqual(prevProps.applications, this.props.applications) ||
      !_.isEqual(prevProps.subApplications, this.props.subApplications)
    ) {
      if (_.intersection(NEW_GRANT_ROLE_PERMISSIONS, this.permObj.roles).length > 0) {
        this.getActionsFromGrants(
          _.isEmpty(this.props.grants) ? prevProps.grants : this.props.grants
        );
      } else if (isSubAOR(this.props.permissions)) {
        this.getActionsFromGrants(
          _.isEmpty(this.props.subApplications)
            ? prevProps.subApplications
            : this.props.subApplications
        );
      }
    }
  }

  state = {
    redirect: false,
    foDataLoaded: false,
    actions: [],
    pendingApplicationMap: {},
    applications: [],
    programCategories: [],
    savedForLater: {},
    thingsToDo: {},
    activePage: 1,
    activePageSavedForLater: 1,
    activeItem: 'Due date',
    activeItemSavedForLater: 'Date in queue',
    sortingDirection: 'Ascending',
    removeSavedForLaterAlertMessageId: '',
  };

  getFoIds = (grants) => {
    // Get truthy FO ids
    return getUniqs(grants, 'fundingOpportunityId');
  };

  getActionsFromGrants = (grants) => {
    if (_.isEmpty(grants) || this.state.foDataLoaded) return null;

    const sortedGrants = _.reverse(_.sortBy(grants, ['modifyDate']));
    let actions = [];
    let count = 0;
    let includedGrants = [];
    const foIds = this.getFoIds(_.concat(grants, this.props.subApplications));

    while (_.has(sortedGrants, count)) {
      let grant = _.get(sortedGrants, count++);
      includedGrants.push(grant);
      const action = this.getActionFromGrant(grant);
      if (action && action.fundingOpportunityId && action.grantId) {
        actions.push(action);
      }
    }

    includedGrants = _.uniqBy(includedGrants, 'grantId');
    return Promise.all(
      _.map(foIds, (foId) =>
        REST.fundingOpportunity.getFundingOpportunity(this.props.token, foId)
      )
    )
      .then((res) => Promise.all(_.map(res, (fo) => fo.json())))

      .then(async (fundingOpportunityData) => {
        this.setState({
          foIds,
          foData: fundingOpportunityData,
        });
        actions = _.map(actions, (action) => {
          action.fundingOpportunityName = _.get(
            _.find(fundingOpportunityData, (fundingOpportunity) => {
              return (
                fundingOpportunity.fundingOpportunityId == action.fundingOpportunityId
              );
            }),
            'fundingOpportunityName',
            'Grant NOFO Name'
          );

          this.setState({
            actions,
          });
          return action;
        });
        this.flattenGrants(includedGrants);
      });
  };

  flattenGrants = (res) => {
    Promise.resolve(res)
      .then((res) => {
        const {foIds} = this.state;
        const appExtFOIds = foIds;
        let pendingApplicationMap = {};
        _.forEach(_.flatMap(res), (app) => {
          _.set(pendingApplicationMap, _.get(app, 'grantId'), app);
        });

        this.setState({
          pendingApplicationMap,
        });

        return Promise.all(
          _.map(appExtFOIds, (foId) =>
            REST.fundingOpportunity.getFundingOpportunitiesAppExtensionsForFO(
              this.props.token,
              foId
            )
          )
        );
      })
      .then((res) => Promise.all(_.map(res, REST.handler.handleResponse)))
      .then((foAppExtRes) => {
        const {foData, pendingApplicationMap} = this.state;

        const appExtensions = _.flatMap(foAppExtRes); // [{obj1}, {obj2}]
        _.forEach(pendingApplicationMap, (pendingApplication) => {
          pendingApplication.dueByDate = _.get(
            _.find(
              appExtensions,
              (appExt) =>
                appExt.grantId === pendingApplication.grantId &&
                appExt.applicationId == pendingApplication.entityId
            ),
            'extendedApplicationEndDate',
            _.get(
              _.find(
                foData,
                (fo) => pendingApplication.fundingOpportunityId == fo.fundingOpportunityId
              ),
              'aplcnEndDate'
            )
          );
        });

        this.setState({
          pendingApplicationMap,
          foDataLoaded: true,
        });
      })
      .catch((error) => console.log(error));
  };

  makeAction = (
    grantData,
    linkText,
    link = '/',
    beforeRouting = () => new Promise((resolve) => resolve())
  ) => ({
    ...grantData,
    render: () => (
      <a
        key={grantData.grantId}
        href="#"
        title={`${linkText} for grant with id: ${grantData.grantId}`}
        onClick={(e) => {
          e.preventDefault();
          beforeRouting().then((res) => {
            this.setState({
              redirect: link,
            });
          });
        }}
      >
        {linkText}
      </a>
    ),
  });

  getTaskIdForGrant = (grantId) => {
    return _.get(
      _.find(this.props.tasks, (task) => task.grantId == grantId),
      'id'
    );
  };

  // intentionally not super extensible until rules svc implementation is prioritized
  getActionFromGrant = (grant) => {
    const relevantGrantData = {
      grantId: grant.grantId || grant.grantNumber,
      fundingOpportunityId: grant.fundingOpportunityId,
    };
    const grantStatus = _.get(grant, 'status');
    const taskId = this.getTaskIdForGrant(_.get(grant, 'grantId'));

    //link will be modified when Award Acceptance task is implemented
    if (_.isEqual(grantStatus, STATUS_AWARD_OFFERED) && taskId) {
      return this.makeAction(
        relevantGrantData,
        'Accept or decline award',
        `/tasks/${taskId}`
      );
    } else if (_.isEqual(grantStatus, STATUS_AWARD_ACCEPTED)) {
      return this.makeAction(
        relevantGrantData,
        'Manage grant',
        `/grant/${_.get(grant, 'grantId')}`
      );
    } else if (_.isEqual(grantStatus, STATUS_SUBMITTED_TO_FEMA)) {
      return this.makeAction(
        relevantGrantData,
        'View application',
        `/grant/${_.get(grant, 'grantId')}`
      );
    } else if (_.includes(BEFORE_FINAL_SUBMISSION_STATUSES, _.get(grant, 'status'))) {
      if (
        canContinueApplications(
          this.props.permissions,
          `${_.get(grant, 'status')}`,
          _.get(grant, 'extendedApplicationEndDate')
            ? appExtension.extendedApplicationEndDate
            : _.get(grant, 'aplcnEndDate'),
          this.props.toggles,
          _.get(grant, 'fundingOpportunityId')
        )
      ) {
        return this.makeAction(
          relevantGrantData,
          'Continue application',
          `/application/${_.get(grant, 'grantId')}-application/edit`
        );
      } else {
        return this.makeAction(
          relevantGrantData,
          'View application',
          `/grant/${_.get(grant, 'grantId')}`
        );
      }
    }
  };

  getGrantOrApplicationContent = (actionLink) => {
    const grantId = actionLink.grantId;
    const pendingApplication = this.state.pendingApplicationMap[grantId];
    let transformedPastDue, evaluatedPastDue;
    if (pendingApplication && pendingApplication.dueByDate) {
      transformedPastDue = ISOToDisplayDate(pendingApplication.dueByDate, {
        showHours: true,
        showDate: true,
        showTimeZone: true,
      });
      evaluatedPastDue = evaluateOperator('isPastDate', transformedPastDue);
    }
    const canContinue =
      (_.get(
        _.find(
          this.state.foData,
          (fo) => actionLink.fundingOpportunityId == fo.fundingOpportunityId
        ),
        'configPath'
      ) === 'passthrough/0' ||
        _.includes(
          BEFORE_FINAL_SUBMISSION_STATUSES,
          _.get(pendingApplication, 'status')
        )) &&
      canViewAndContinueApplication(this.props.permissions);

    return this.state.foDataLoaded ? (
      <Item.Content className="homepage">
        <h4 style={{marginBottom: 0}}>
          {_.includes(this.props.toggles, 'disasterSiteNav') ? (
            <a
              key={`link-${actionLink.fundingOpportunityName}`}
              href="#"
              title={`View funding opportunity: ${actionLink.fundingOpportunityName}`}
              onClick={(e) => {
                e.preventDefault();
                new Promise((resolve) => resolve()).then((res) => {
                  this.setState({
                    redirect: `/fundingOpportunity/${actionLink.fundingOpportunityId}`,
                  });
                });
              }}
            >
              {actionLink.fundingOpportunityName}
            </a>
          ) : (
            <>{actionLink.fundingOpportunityName}</>
          )}
        </h4>
        <div>
          Application ID:{' '}
          <span className="homepage-details">
            {canContinue
              ? this.makeAction(
                  pendingApplication,
                  pendingApplication.grantId,
                  `/application/${pendingApplication.grantId}-application/edit`
                ).render()
              : this.makeAction(
                  pendingApplication,
                  pendingApplication.grantId,
                  `/grant/${pendingApplication.grantId}`
                ).render()}
          </span>
          <br />
          {pendingApplication.dueByDate && evaluatedPastDue && (
            <img className="due-date-alert" src={'/assets/error-alert.svg'} />
          )}
          Due date:{' '}
          <span className={evaluatedPastDue && 'pastDueColor'}>
            <span className="homepage-details">
              {pendingApplication.dueByDate
                ? `${ISOToDisplayDate(transformedPastDue, {
                    showHours: true,
                    showDate: true,
                  })} ET`
                : 'Not available'}
            </span>
          </span>
          <br />
          Modified date:{' '}
          <span className="homepage-details">
            {pendingApplication.modifyDate
              ? `${ISOToDisplayDate(pendingApplication.modifyDate, {
                  showHours: true,
                  showDate: true,
                })} ET`
              : 'Not available'}
          </span>
          <br />
          Recipient:{' '}
          <span className="homepage-details">{pendingApplication.organizationName}</span>
          <br />
          {pendingApplication.subOrganizationName ? (
            <>
              Subrecipient:{' '}
              <span className="homepage-details">
                {pendingApplication.subOrganizationName}
              </span>
              <br />{' '}
            </>
          ) : (
            ''
          )}
        </div>
      </Item.Content>
    ) : null;
  };

  render() {
    const {
      actions,
      redirect,
      programCategories,
      sortingDirection,
      activeItem,
      activeItemSavedForLater,
      activePage,
      activePageSavedForLater,
    } = this.state;
    const {
      applications,
      subApplications,
      saveForLater,
      thingsToDo,
      thingsToDoTotal,
    } = this.props;

    const sortedApplications = _.sortBy(applications, function (dateObj) {
      return new Date(dateObj.modifyDate);
    }).reverse();
    const sortedSubApplications = _.sortBy(subApplications, function (dateObj) {
      return new Date(dateObj.modifyDate);
    }).reverse();
    const user = isSubAOR(this.props.permissions);
    let apps = [];
    let subApps = [];
    let passthrough = [];

    _.forEach(actions, (action) => {
      if (
        _.get(
          _.find(
            this.state.foData,
            (fo) => action.fundingOpportunityId == fo.fundingOpportunityId
          ),
          'configPath'
        ) === 'passthrough/0'
      ) {
        passthrough.push(action);
      }
    });

    if (!_.isEmpty(sortedApplications)) {
      apps = sortedApplications.slice(0, NUM_ACTIONS_TO_SHOW);
      apps = _.uniqBy(apps, 'grantId');
    }
    if (!_.isEmpty(sortedSubApplications)) {
      subApps = _.uniqBy(sortedSubApplications, 'entityId');
    }

    let grants = _.concat(actions, apps);

    let awards = _.filter(grants, (grant) =>
      _.includes(
        STATUS_AWARD_OFFERED,
        _.get(this.state.pendingApplicationMap[_.get(grant, 'grantId')], 'status')
      )
    ).slice(0, NUM_ACTIONS_TO_SHOW);

    grants = _.filter(grants, (grant) =>
      _.includes(
        BEFORE_FINAL_SUBMISSION_STATUSES,
        _.get(this.state.pendingApplicationMap[_.get(grant, 'grantId')], 'status')
      )
    ).concat(passthrough);
    grants = _.uniqBy(grants, 'grantId');

    _.forEach(grants, (grant) => {
      grant.modifyDate = this.state.pendingApplicationMap[
        _.get(grant, 'grantId')
      ]?.modifyDate;
    });

    grants = _.reverse(_.sortBy(grants, ['modifyDate']));

    let countGrantActions = _.size(grants);
    grants = grants.slice(0, NUM_ACTIONS_TO_SHOW);

    subApps = _.filter(subApps, (subApp) =>
      _.includes(BEFORE_FINAL_SUBMISSION_STATUSES, subApp.status)
    );

    let countSubAppsActions = _.size(subApps);
    subApps = subApps.slice(0, NUM_ACTIONS_TO_SHOW);

    if (redirect) {
      return <Redirect push to={redirect} />;
    }

    let permObj = _.reduce(
      this.props.permissions,
      (result, permission) => {
        const [entityTypeId, , roleId] = permission.split(':');
        if (_.indexOf(result.types, entityTypeId) === -1) {
          result.entityTypes.push(entityTypeId);
        }
        if (_.indexOf(result.roles, roleId) === -1) {
          result.roles.push(roleId);
        }
        return result;
      },
      {entityTypes: [], roles: []}
    );

    const isOnlySubRecipient =
      _.intersection(NEW_GRANT_ROLE_PERMISSIONS, permObj.roles).length == 0 &&
      _.intersection(NEW_SUB_RECPT_PERMISSIONS, permObj.roles).length > 0;

    let disasterSiteNav = _.includes(this.props.toggles, 'disasterSiteNav');
    let panes = [];

    if (_.intersection(NEW_GRANT_ROLE_PERMISSIONS, permObj.roles).length) {
      panes = [
        {
          menuItem: (
            <Menu.Item key="myGrants" className="menu-item">
              My grants ({countGrantActions})
            </Menu.Item>
          ),
          render: () => (
            <>
              <Tab.Pane
                attached={false}
                style={{border: 'none', 'box-shadow': 'none', padding: '14px 0'}}
              >
                <Item.Group divided>
                  {_.size(grants) > 0 ? (
                    _.map(grants, (actionLink, index) =>
                      actionLink ? (
                        actionLink.grantId && (
                          <Item key={index}>
                            {this.getGrantOrApplicationContent(
                              actionLink,
                              isOnlySubRecipient
                            )}
                          </Item>
                        )
                      ) : (
                        <Loader active inline="centered" content="Loading" />
                      )
                    )
                  ) : (
                    <p style={{fontWeight: 400}}>There are no grant actions.</p>
                  )}
                </Item.Group>
              </Tab.Pane>
              <br></br>
              <Link to="/grants">View all</Link>
            </>
          ),
        },
      ];
    }

    if (user) {
      panes = [
        ...panes,
        {
          menuItem: (
            <Menu.Item key="mySubgrants" className="menu-item">
              My subgrants ({countSubAppsActions})
            </Menu.Item>
          ),
          render: () => (
            <>
              <Tab.Pane
                attached={false}
                style={{border: 'none', boxShadow: 'none', padding: '14px 0'}}
              >
                <Item.Group divided>
                  {_.size(subApps) > 0 ? (
                    _.map(subApps, (actionLink, index) => {
                      let transformedPastDue, evaluatedPastDue;
                      if (actionLink && actionLink.fundingOpportunityId) {
                        transformedPastDue = ISOToDisplayDate(
                          _.get(
                            _.find(
                              this.state.foData,
                              (fo) =>
                                actionLink.fundingOpportunityId == fo.fundingOpportunityId
                            ),
                            'aplcnEndDate'
                          ),
                          {
                            showHours: true,
                            showDate: true,
                            showTimeZone: true,
                          }
                        );
                        evaluatedPastDue = evaluateOperator(
                          'isPastDate',
                          transformedPastDue
                        );
                      }
                      const foName = actionLink.fundingOpportunityId
                        ? _.get(
                            _.find(
                              this.state.foData,
                              (fo) =>
                                actionLink.fundingOpportunityId == fo.fundingOpportunityId
                            ),
                            'fundingOpportunityName'
                          )
                        : _.get(
                            _.find(programCategories, (pc) => {
                              if (pc.id === actionLink.categoryId) {
                                return pc;
                              }
                            }),
                            'displayText'
                          );
                      return actionLink ? (
                        <Item key={index} className="homepage">
                          <Item.Content>
                            <h4 style={{marginBottom: 0}}>
                              {disasterSiteNav ? (
                                <a
                                  key={`link-${foName}`}
                                  href="#"
                                  title={`View funding opportunity: ${foName}`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    if (!isOnlySubRecipient)
                                      new Promise((resolve) => resolve()).then((res) => {
                                        this.setState({
                                          redirect: `/fundingOpportunity/${actionLink.fundingOpportunityId}`,
                                        });
                                      });
                                  }}
                                >
                                  {foName}
                                </a>
                              ) : (
                                <>{foName}</>
                              )}
                            </h4>
                            <div>
                              Title:{' '}
                              <span className="homepage-details">
                                {actionLink.payload !== undefined &&
                                actionLink.payload.applicationTitle !== undefined ? (
                                  <a
                                    key={actionLink.payload.applicationTitle}
                                    href="#"
                                    title={`Continue subapplication: ${actionLink.payload.applicationTitle}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      new Promise((resolve) => resolve()).then((res) => {
                                        this.setState({
                                          redirect: `/subApplication/${actionLink.entityId}`,
                                        });
                                      });
                                    }}
                                  >
                                    {actionLink.payload.applicationTitle}
                                  </a>
                                ) : (
                                  'No application title provided ' + actionLink.entityType
                                )}
                              </span>
                              <br />
                              {actionLink.fundingOpportunityId && evaluatedPastDue && (
                                <img
                                  className="due-date-alert"
                                  src={'/assets/error-alert.svg'}
                                />
                              )}
                              Due date:{' '}
                              <span className={evaluatedPastDue && 'pastDueColor'}>
                                <span className="homepage-details">
                                  {actionLink.fundingOpportunityId
                                    ? `${ISOToDisplayDate(transformedPastDue, {
                                        showHours: true,
                                        showDate: true,
                                      })} ET`
                                    : 'Not available'}
                                </span>
                              </span>
                              <br />
                              Modified date:{' '}
                              <span className="homepage-details">
                                {actionLink.modifyDate
                                  ? `${ISOToDisplayDate(actionLink.modifyDate, {
                                      showHours: true,
                                      showDate: true,
                                    })} ET `
                                  : 'Not available'}
                              </span>
                              <br />
                              Recipient:{' '}
                              <span className="homepage-details">
                                {actionLink.organizationName}
                              </span>
                              <br />
                              {actionLink.subOrganizationName ? (
                                <>
                                  Subrecipient:{' '}
                                  <span className="homepage-details">
                                    {actionLink.subOrganizationName}
                                  </span>
                                  <br />{' '}
                                </>
                              ) : (
                                ''
                              )}
                            </div>
                          </Item.Content>
                        </Item>
                      ) : (
                        <Loader active inline="centered" content="Loading" />
                      );
                    })
                  ) : (
                    <p style={{fontWeight: 400}}>There are no subgrant actions.</p>
                  )}
                </Item.Group>
              </Tab.Pane>
              <br></br>
              <Link to="/grants">View all</Link>
            </>
          ),
        },
      ];
    }

    if (_.intersection(NEW_AWARD_PERMISSIONS, permObj.roles).length) {
      panes = [
        ...panes,
        {
          menuItem: (
            <Menu.Item key="myAwards" className="menu-item">
              My awards ({_.size(awards)})
            </Menu.Item>
          ),
          render: () => (
            <>
              <Tab.Pane
                attached={false}
                style={{border: 'none', 'box-shadow': 'none', padding: '14px 0'}}
              >
                <Item.Group divided>
                  {_.size(awards) > 0 ? (
                    _.map(awards, (actionLink, index) =>
                      actionLink ? (
                        actionLink.grantId && (
                          <Item key={index} className="homepage">
                            <Item.Content>
                              <h4 style={{marginBottom: 0}}>
                                {disasterSiteNav ? (
                                  <a
                                    key={`link-${actionLink.fundingOpportunityName}`}
                                    href="#"
                                    title={`View funding opportunity: ${actionLink.fundingOpportunityName}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      new Promise((resolve) => resolve()).then((res) => {
                                        this.setState({
                                          redirect: `/fundingOpportunity/${actionLink.fundingOpportunityId}`,
                                        });
                                      });
                                    }}
                                  >
                                    {actionLink.fundingOpportunityName}
                                  </a>
                                ) : (
                                  <>{actionLink.fundingOpportunityName}</>
                                )}
                              </h4>
                              <div>
                                Grant ID:{' '}
                                <span className="homepage-details">
                                  {actionLink.grantId}
                                </span>
                                <br />
                                Due date:{' '}
                                <span className="homepage-details">
                                  {actionLink.fundingOpportunityId
                                    ? `${ISOToDisplayDate(
                                        _.get(
                                          _.find(
                                            this.state.foData,
                                            (fo) =>
                                              actionLink.fundingOpportunityId ==
                                              fo.fundingOpportunityId
                                          ),
                                          'aplcnEndDate'
                                        ),
                                        {
                                          showHours: true,
                                          showDate: true,
                                        }
                                      )} ET`
                                    : 'Not available'}
                                </span>
                                <br />
                                Modified date:{' '}
                                <span className="homepage-details">
                                  {actionLink.modifyDate
                                    ? `${ISOToDisplayDate(actionLink.modifyDate, {
                                        showHours: true,
                                        showDate: true,
                                      })} ET`
                                    : 'Not available'}
                                </span>
                                <br />
                                {
                                  <a
                                    key={actionLink.grantId}
                                    href="#"
                                    title={`Accept or decline award for grant with id: ${actionLink.grantId}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      new Promise((resolve) => resolve()).then((res) => {
                                        this.setState({
                                          redirect: `/tasks/${this.getTaskIdForGrant(
                                            actionLink.grantId
                                          )}`,
                                        });
                                      });
                                    }}
                                  >
                                    Accept or decline award
                                  </a>
                                }
                              </div>
                            </Item.Content>
                          </Item>
                        )
                      ) : (
                        <Loader active inline="centered" content="Loading" />
                      )
                    )
                  ) : (
                    <p style={{fontWeight: 400}}>There are no award actions.</p>
                  )}
                </Item.Group>
              </Tab.Pane>
              <br></br>
              <Link to="/grants">View all</Link>
            </>
          ),
        },
      ];
    }
    if (
      (_.intersection(NEW_GRANT_ROLE_PERMISSIONS, permObj.roles).length ||
        _.intersection(NEW_SUB_RECPT_PERMISSIONS, permObj.roles).length) &&
      _.includes(this.props.toggles, 'disasterSiteNav') &&
      canViewThingsToDo(this.props.permissions)
    ) {
      panes = [
        ...panes,
        {
          menuItem: (
            <Menu.Item key="myThingsToDo" className="menu-item">
              Things to do ({thingsToDoTotal})
            </Menu.Item>
          ),
          render: () => (
            <>
              <Link to="/thingsToDo">View all things to do ({thingsToDoTotal})</Link>
              <br></br>
              <Tab.Pane
                attached={false}
                style={{border: 'none', 'box-shadow': 'none', padding: '14px 0'}}
              >
                <Menu borderless secondary>
                  <Dropdown item text={`Sort by: ${activeItem}`} style={{paddingLeft: 0}}>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        name="Funding opportunity name"
                        active={activeItem === 'Funding opportunity name'}
                        onClick={() => {
                          this.setState({activeItem: 'Funding opportunity name'});
                          this.sortThingsToDo(
                            sortingDirection,
                            'Funding opportunity name',
                            activePage
                          );
                        }}
                      >
                        Funding opportunity name
                      </Dropdown.Item>
                      <Dropdown.Item
                        name="Organization"
                        active={activeItem === 'Organization'}
                        onClick={() => {
                          this.setState({activeItem: 'Organization'});
                          this.sortThingsToDo(
                            sortingDirection,
                            'Organization',
                            activePage
                          );
                        }}
                      >
                        Organization
                      </Dropdown.Item>
                      <Dropdown.Item
                        name="Suborganization"
                        active={activeItem === 'Suborganization'}
                        onClick={() => {
                          this.setState({activeItem: 'Suborganization'});
                          this.sortThingsToDo(
                            sortingDirection,
                            'Suborganization',
                            activePage
                          );
                        }}
                      >
                        Suborganization
                      </Dropdown.Item>
                      <Dropdown.Item
                        name="Date in queue"
                        active={activeItem === 'Date in queue'}
                        onClick={() => {
                          this.setState({activeItem: 'Date in queue'});
                          this.sortThingsToDo(
                            sortingDirection,
                            'Date in queue',
                            activePage
                          );
                        }}
                      >
                        Date in queue
                      </Dropdown.Item>
                      <Dropdown.Item
                        name="Due date"
                        active={activeItem === 'Due date'}
                        onClick={() => {
                          this.setState({activeItem: 'Due date'});
                          this.sortThingsToDo(sortingDirection, 'Due date', activePage);
                        }}
                      >
                        Due date
                      </Dropdown.Item>
                      <Dropdown.Item
                        name="Grant ID"
                        active={activeItem === 'Grant ID'}
                        onClick={() => {
                          this.setState({activeItem: 'Grant ID'});
                          this.sortThingsToDo(sortingDirection, 'Grant ID', activePage);
                        }}
                      >
                        Grant ID
                      </Dropdown.Item>
                      <Dropdown.Item
                        name="Subgrant ID"
                        active={activeItem === 'Subgrant ID'}
                        onClick={() => {
                          this.setState({activeItem: 'Subgrant ID'});
                          this.sortThingsToDo(
                            sortingDirection,
                            'Subgrant ID',
                            activePage
                          );
                        }}
                      >
                        Subgrant ID
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  <Menu.Menu>
                    <Radio
                      className="homepageRadioBtn"
                      name="Ascending"
                      value="Ascending"
                      label="Ascending (A-Z)"
                      title="Ascending"
                      checked={sortingDirection === 'Ascending'}
                      onClick={() => {
                        this.setState({sortingDirection: 'Ascending'});
                        this.sortThingsToDo('Ascending', activeItem, activePage);
                      }}
                    />
                    <Radio
                      className="homepageRadioBtn"
                      name="Descending"
                      value="Descending"
                      label="Descending (Z-A)"
                      title="Descending"
                      checked={sortingDirection === 'Descending'}
                      onClick={() => {
                        this.setState({sortingDirection: 'Descending'});
                        this.sortThingsToDo('Descending', activeItem, activePage);
                      }}
                    />
                  </Menu.Menu>
                </Menu>
                <Item.Group divided>
                  {thingsToDo?.total > 0 ? (
                    _.map(thingsToDo?.items, (actionLink, index) => {
                      let transformedPastDue, evaluatedPastDue;
                      if (actionLink.dueDate) {
                        transformedPastDue = ISOToDisplayDate(actionLink.dueDate, {
                          showHours: true,
                          showDate: true,
                          showTimeZone: true,
                        });
                        evaluatedPastDue = evaluateOperator(
                          'isPastDate',
                          transformedPastDue
                        );
                      }
                      return actionLink ? (
                        <Item key={index} className="homepage">
                          <Item.Content>
                            <h4 style={{marginBottom: 0}}>
                              <a
                                key={`link-${actionLink.fundingOpportunityName}`}
                                href="#"
                                title={`View funding opportunity: ${actionLink.fundingOpportunityName}`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (!isOnlySubRecipient)
                                    new Promise((resolve) => resolve()).then((res) => {
                                      this.setState({
                                        redirect: `/fundingOpportunity/${actionLink.fundingOpportunityId}`,
                                      });
                                    });
                                }}
                              >
                                {actionLink.fundingOpportunityName}
                              </a>
                            </h4>
                            <div>
                              Type:{' '}
                              <span className="homepage-details">
                                <a
                                  key={actionLink.grantId}
                                  href="#"
                                  title={`Continue working on this ${
                                    ENTITY_TYPE_NAME_MAP[actionLink.entityType]
                                  }`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    new Promise((resolve) => resolve()).then((res) => {
                                      this.setState({
                                        redirect: `${actionLink.actionVal}`,
                                      });
                                    });
                                  }}
                                >
                                  {ENTITY_TYPE_NAME_MAP[actionLink.entityType]}
                                </a>
                              </span>
                              <br />
                              {actionLink.subGrantId
                                ? 'Subgrant ID: '
                                : actionLink.payload &&
                                  actionLink.payload.scopeOfWork &&
                                  actionLink.payload.scopeOfWork.proposedActivityTitle
                                ? 'Title: '
                                : 'Grant ID: '}
                              <span className="homepage-details">
                                {actionLink.subGrantId
                                  ? actionLink.subGrantId
                                  : actionLink.payload &&
                                    actionLink.payload.scopeOfWork &&
                                    actionLink.payload.scopeOfWork.proposedActivityTitle
                                  ? actionLink.payload.scopeOfWork.proposedActivityTitle
                                  : actionLink.grantId}
                              </span>
                              <br />
                              Status:{' '}
                              <span className="homepage-details">
                                {ASSOCIATED_ENTITY_STATUSES[actionLink.status]}
                              </span>
                              <br />
                              Recipient:{' '}
                              <span className="homepage-details">
                                {actionLink.organizationName}
                              </span>
                              <br />
                              {actionLink.subOrganizationName && !isOnlySubRecipient && (
                                <>
                                  Subrecipient:{' '}
                                  <span className="homepage-details">
                                    {actionLink.subOrganizationName}
                                  </span>
                                  <br />
                                </>
                              )}
                              {actionLink.dueDate && evaluatedPastDue && (
                                <img
                                  className="due-date-alert"
                                  src={'/assets/error-alert.svg'}
                                />
                              )}
                              Due date:{' '}
                              <span className={evaluatedPastDue && 'pastDueColor'}>
                                <span className="homepage-details">
                                  {actionLink.dueDate
                                    ? `${ISOToDisplayDate(transformedPastDue, {
                                        showHours: true,
                                        showDate: true,
                                      })} ET`
                                    : 'Not available'}
                                </span>
                              </span>
                              <br />
                            </div>
                          </Item.Content>
                        </Item>
                      ) : (
                        <Loader active inline="centered" content="Loading" />
                      );
                    })
                  ) : (
                    <p style={{fontWeight: 400}}>There are no pending tasks.</p>
                  )}
                </Item.Group>
                <Pagination
                  activePage={activePage}
                  totalPages={Math.ceil(thingsToDoTotal / 10)}
                  onPageChange={(e, {activePage}) => {
                    this.setState({activePage});
                    this.sortThingsToDo(sortingDirection, activeItem, activePage);
                  }}
                />
              </Tab.Pane>
            </>
          ),
        },
      ];
    }

    if (
      (_.intersection(NEW_GRANT_ROLE_PERMISSIONS, permObj.roles).length ||
        _.intersection(NEW_SUB_RECPT_PERMISSIONS, permObj.roles).length) &&
      _.includes(this.props.toggles, 'disasterSiteNav')
    ) {
      panes = [
        ...panes,
        {
          menuItem: (
            <Menu.Item key="mySaveForLater" className="menu-item">
              Saved for later ({saveForLater?.total})
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane
              attached={false}
              style={{border: 'none', 'box-shadow': 'none', padding: '14px 0'}}
            >
              <Menu borderless secondary>
                <Dropdown
                  item
                  text={`Sort by: ${activeItemSavedForLater}`}
                  style={{paddingLeft: 0}}
                >
                  <Dropdown.Menu>
                    <Dropdown.Item
                      name="Funding opportunity name"
                      active={activeItemSavedForLater === 'Funding opportunity name'}
                      onClick={() => {
                        this.setState({
                          activeItemSavedForLater: 'Funding opportunity name',
                        });
                        this.sortSavedForLater(
                          sortingDirection,
                          'Funding opportunity name',
                          activePageSavedForLater
                        );
                      }}
                    >
                      Funding opportunity name
                    </Dropdown.Item>
                    <Dropdown.Item
                      name="Organization"
                      active={activeItemSavedForLater === 'Organization'}
                      onClick={() => {
                        this.setState({activeItemSavedForLater: 'Organization'});
                        this.sortSavedForLater(
                          sortingDirection,
                          'Organization',
                          activePageSavedForLater
                        );
                      }}
                    >
                      Organization
                    </Dropdown.Item>
                    <Dropdown.Item
                      name="Suborganization"
                      active={activeItemSavedForLater === 'Suborganization'}
                      onClick={() => {
                        this.setState({activeItemSavedForLater: 'Suborganization'});
                        this.sortSavedForLater(
                          sortingDirection,
                          'Suborganization',
                          activePageSavedForLater
                        );
                      }}
                    >
                      Suborganization
                    </Dropdown.Item>
                    <Dropdown.Item
                      name="Date in queue"
                      active={activeItemSavedForLater === 'Date in queue'}
                      onClick={() => {
                        this.setState({activeItemSavedForLater: 'Date in queue'});
                        this.sortSavedForLater(
                          sortingDirection,
                          'Date in queue',
                          activePageSavedForLater
                        );
                      }}
                    >
                      Date in queue
                    </Dropdown.Item>
                    <Dropdown.Item
                      name="Due date"
                      active={activeItemSavedForLater === 'Due date'}
                      onClick={() => {
                        this.setState({activeItemSavedForLater: 'Due date'});
                        this.sortSavedForLater(
                          sortingDirection,
                          'Due date',
                          activePageSavedForLater
                        );
                      }}
                    >
                      Due date
                    </Dropdown.Item>
                    <Dropdown.Item
                      name="Grant ID"
                      active={activeItemSavedForLater === 'Grant ID'}
                      onClick={() => {
                        this.setState({activeItemSavedForLater: 'Grant ID'});
                        this.sortSavedForLater(
                          sortingDirection,
                          'Grant ID',
                          activePageSavedForLater
                        );
                      }}
                    >
                      Grant ID
                    </Dropdown.Item>
                    <Dropdown.Item
                      name="Subgrant ID"
                      active={activeItemSavedForLater === 'Subgrant ID'}
                      onClick={() => {
                        this.setState({activeItemSavedForLater: 'Subgrant ID'});
                        this.sortSavedForLater(
                          sortingDirection,
                          'Subgrant ID',
                          activePageSavedForLater
                        );
                      }}
                    >
                      Subgrant ID
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <Menu.Menu>
                  <Radio
                    className="homepageRadioBtn"
                    name="Ascending"
                    value="Ascending"
                    label="Ascending (A-Z)"
                    title="Ascending"
                    checked={sortingDirection === 'Ascending'}
                    onClick={() => {
                      this.setState({sortingDirection: 'Ascending'});
                      this.sortSavedForLater(
                        'Ascending',
                        activeItemSavedForLater,
                        activePageSavedForLater
                      );
                    }}
                  />
                  <Radio
                    className="homepageRadioBtn"
                    name="Descending"
                    value="Descending"
                    label="Descending (Z-A)"
                    title="Descending"
                    checked={sortingDirection === 'Descending'}
                    onClick={() => {
                      this.setState({sortingDirection: 'Descending'});
                      this.sortSavedForLater(
                        'Descending',
                        activeItemSavedForLater,
                        activePageSavedForLater
                      );
                    }}
                  />
                </Menu.Menu>
              </Menu>
              {this.state.removeSavedForLaterAlertMessageId ? (
                <Alert type="success">
                  You have successfully unsaved this{' '}
                  {this.state.removeSavedForLaterAlertMessageId}
                </Alert>
              ) : (
                ''
              )}
              <Item.Group divided>
                {saveForLater?.total > 0 ? (
                  _.map(saveForLater?.items, (actionLink, index) => {
                    actionLink.actionVal =
                      actionLink.inner_hits.data_type == 'data'
                        ? `/${actionLink.entityType}/${actionLink.entityId}/edit`
                        : `/task/${actionLink.inner_hits.task_id}`;
                    let transformedPastDue = ISOToDisplayDate(actionLink.dueDate, {
                      showHours: true,
                      showDate: true,
                      showTimeZone: true,
                    });
                    let evaluatedPastDue = evaluateOperator(
                      'isPastDate',
                      transformedPastDue
                    );
                    return actionLink ? (
                      <Item key={index} className="homepage">
                        <Item.Content>
                          <h4 style={{marginBottom: 0}}>
                            <a
                              key={`link-${actionLink.fundingOpportunityName}`}
                              href="#"
                              title={`View funding opportunity: ${actionLink.fundingOpportunityName}`}
                              onClick={(e) => {
                                e.preventDefault();
                                if (!isOnlySubRecipient)
                                  new Promise((resolve) => resolve()).then((res) => {
                                    this.setState({
                                      redirect: `/fundingOpportunity/${actionLink.fundingOpportunityId}`,
                                    });
                                  });
                              }}
                            >
                              {actionLink.fundingOpportunityName}
                            </a>
                          </h4>
                          <div>
                            Type:{' '}
                            <span className="homepage-details">
                              <a
                                key={actionLink.grantId}
                                href="#"
                                title={`Continue working on this ${
                                  ENTITY_TYPE_NAME_MAP[actionLink.entityType]
                                }`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  new Promise((resolve) => resolve()).then((res) => {
                                    this.setState({
                                      redirect: `${actionLink.actionVal}`,
                                    });
                                  });
                                }}
                              >
                                {ENTITY_TYPE_NAME_MAP[actionLink.entityType]}
                              </a>
                            </span>
                            <br />
                            {actionLink.subGrantId
                              ? 'Subgrant ID: '
                              : actionLink.payload &&
                                actionLink.payload.scopeOfWork &&
                                actionLink.payload.scopeOfWork.proposedActivityTitle
                              ? 'Title: '
                              : 'Grant ID: '}
                            <span className="homepage-details">
                              {actionLink.subGrantId
                                ? actionLink.subGrantId
                                : actionLink.payload &&
                                  actionLink.payload.scopeOfWork &&
                                  actionLink.payload.scopeOfWork.proposedActivityTitle
                                ? actionLink.payload.scopeOfWork.proposedActivityTitle
                                : actionLink.grantId}
                            </span>
                            <br />
                            Status:{' '}
                            <span className="homepage-details">
                              {ASSOCIATED_ENTITY_STATUSES[actionLink.status]}
                            </span>
                            <br />
                            Recipient:{' '}
                            <span className="homepage-details">
                              {actionLink.organizationName}
                            </span>
                            <br />
                            {actionLink.subOrganizationName && !isOnlySubRecipient && (
                              <>
                                Subrecipient:{' '}
                                <span className="homepage-details">
                                  {actionLink.subOrganizationName}
                                </span>
                                <br />
                              </>
                            )}
                            {actionLink.dueDate && evaluatedPastDue && (
                              <img
                                className="due-date-alert"
                                src={'/assets/error-alert.svg'}
                              />
                            )}
                            Due date:{' '}
                            <span className={evaluatedPastDue && 'pastDueColor'}>
                              <span className="homepage-details">
                                {actionLink.dueDate
                                  ? `${ISOToDisplayDate(transformedPastDue, {
                                      showHours: true,
                                      showDate: true,
                                    })} ET`
                                  : 'Not available'}
                              </span>
                            </span>
                            <br />
                            <a
                              key={actionLink.grantId}
                              href="#"
                              title={`Remove this ${
                                ENTITY_TYPE_NAME_MAP[actionLink.entityType]
                              } from your saved for later`}
                              onClick={(e) => {
                                e.preventDefault();
                                new Promise((resolve) => resolve())
                                  .then(() => {
                                    this.removeSavedForLater(
                                      actionLink.inner_hits.id,
                                      activePageSavedForLater,
                                      activeItemSavedForLater,
                                      sortingDirection
                                    );
                                  })
                                  .then(() => {
                                    this.setState({
                                      removeSavedForLaterAlertMessageId:
                                        actionLink.fundingOpportunityName,
                                    });
                                  });
                              }}
                            >
                              Remove
                            </a>
                          </div>
                        </Item.Content>
                      </Item>
                    ) : (
                      <Loader active inline="centered" content="Loading" />
                    );
                  })
                ) : (
                  <p style={{fontWeight: 400}}>There are no Saved tasks.</p>
                )}
              </Item.Group>
              <Pagination
                activePage={activePageSavedForLater}
                totalPages={Math.ceil(saveForLater?.total / 10)}
                onPageChange={(e, {activePageSavedForLater}) => {
                  this.setState({activePageSavedForLater});
                  this.sortSavedForLater(
                    sortingDirection,
                    activeItemSavedForLater,
                    activePageSavedForLater
                  );
                }}
              />
            </Tab.Pane>
          ),
        },
      ];
    }

    //Hack to make coverage for the anonymous functions
    if (!_.isEmpty(panes)) {
      _.forEach(panes, (pane) => {
        pane.render();
      });
    }

    return (
      <Grid.Column width={9} className="homepage homepage-grid">
        <Grid.Row>
          <h3>My work</h3>
        </Grid.Row>
        <Card fluid>
          <Card.Content id="homepage-link">
            <Tab
              menu={{color: 'blue', secondary: true, pointing: true}}
              panes={panes}
              onTabChange={(e) => {
                this.setState({
                  removeSavedForLaterAlertMessageId: null,
                });
              }}
            />
          </Card.Content>
        </Card>
      </Grid.Column>
    );
  }
}
export const mapStateToProps = (state) => {
  return {
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps, null)(MyWorkCard);
